// https://fluentsite.z22.web.core.windows.net/quick-start
import {
  FluentProvider,
  teamsLightTheme,
  teamsDarkTheme,
  teamsHighContrastTheme,
  tokens,
  Button,
} from "@fluentui/react-components";
import { useEffect } from "react";
import { app } from "@microsoft/teams-js";
import { TeamsFxContext } from "./Context";
// Only takes effect for proxy purpose when REACT_APP_HOOK_FOR_PROXY is set in the environment.
import "./HookForProxy";
import { useTeams } from "./sample/lib/useTeams";
import { store, getUserManager } from "../redux/store";
import { OidcProvider } from "redux-oidc-2";
import { Provider } from "react-redux";
import AppRoutes from "./AppRoutes";


/**
 * The main app which handles the initialization and routing
 * of the app.
 */
export default function App() {
  const path = window.location.pathname + window.location.hash;
  const [{ loading, themeString, theme }] = useTeams();
  //const { token, login, logout } = useAuth();
  useEffect(() => {
    loading &&
      app.initialize().then(() => {
        // Hide the loading indicator.
        app.notifySuccess();
      });
  }, [loading]);

  useEffect(() => {
    console.log("App themeString changed:", themeString);
    document.documentElement.setAttribute('data-bs-theme', themeString === "dark" ? "dark" : "light");
    //add dark.css to document headerr

    const linkId = "theme-link";
    let link = document.getElementById(linkId) as HTMLLinkElement
    if (!link) {
      link = document.createElement("link");
      link.id = linkId;
      link.rel = "stylesheet";
      document.head.appendChild(link);
    }
    link.href = themeString === "dark" ? "./style/dark.css" : "./style/light.css";

  }, [themeString]);

  //console.log("Auth token:", token);

  return (
    <Provider store={store}>
      <OidcProvider store={store as any} userManager={getUserManager()}>
        <TeamsFxContext.Provider value={{ theme, themeString }}>
          <FluentProvider
            theme={
              themeString === "dark"
                ? teamsDarkTheme
                : themeString === "contrast"
                  ? teamsHighContrastTheme
                  : {
                    ...teamsLightTheme,
                    colorNeutralBackground3: "#eeeeee",
                  }
            }
            style={{ background: tokens.colorNeutralBackground3 }}>
            <AppRoutes />
          </FluentProvider>
        </TeamsFxContext.Provider>
      </OidcProvider>
    </Provider>
  );
}
